import type {Configuration} from '../configuration';
import type {AxiosInstance, AxiosPromise, RawAxiosRequestConfig} from 'axios';
import {BASE_PATH, BaseAPI, operationServerMap, RequestArgs} from '../base';
import globalAxios from 'axios';
import {
  assertParamExists,
  createRequestFunction,
  DUMMY_BASE_URL,
  serializeDataIfNeeded,
  setSearchParams,
  toPathString,
} from '../common';
import {
  OrgUser,
  OrgUserUpdateReq,
  OrgUsers,
  OrgUserSendInviteReq,
  OrgUserSendInviteCallbackReq,
  OrgUserSendInviteCallbackRsp,
  OrgUserSendInviteRsp,
  OrgUserUpdateCallMethodReq,
  OrgUserUpdateCallMethodRsp,
  OrgUserBatchUpdateCallMethodReq,
  OrgUserBatchUpdateCallMethodRsp,
} from '../types/orgUser';

/**
 * OrgUserServiceApi - axios parameter creator
 * @export
 */
export const OrgUserServiceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * 用户创建
     * @summary 用户创建
     * @param {OrgUser} orgUser
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orgUserServiceCreate: async (
      orgUser: OrgUser,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgUser' is not null or undefined
      assertParamExists('orgUserServiceCreate', 'orgUser', orgUser);
      const localVarPath = `/org_user/org_user`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        orgUser,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 用户删除
     * @summary 用户删除
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orgUserServiceDelete: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('orgUserServiceDelete', 'id', id);
      const localVarPath = `/org_user/org_user/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'DELETE', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 用户详情
     * @summary 用户详情
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orgUserServiceDetail: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('orgUserServiceDetail', 'id', id);
      const localVarPath = `/org_user/org_user/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 用户列表查询
     * @summary 用户列表查询
     * @param {string} [name]
     * @param {string} [orgId]
     * @param {number} [pageSize] 当前分页大小
     * @param {number} [pageNum] 当前页数
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orgUserServiceFind: async (
      name?: string,
      orgId?: string,
      pageSize?: number,
      pageNum?: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/org_user/org_users`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (name !== undefined) {
        localVarQueryParameter['name'] = name;
      }

      if (orgId !== undefined) {
        localVarQueryParameter['orgId'] = orgId;
      }

      if (pageSize !== undefined) {
        localVarQueryParameter['page.size'] = pageSize;
      }

      if (pageNum !== undefined) {
        localVarQueryParameter['page.num'] = pageNum;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 用户邀请
     * @summary 用户邀请
     * @param {OrgUserSendInviteReq} orgUserSendInviteReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orgUserServiceSendInvite: async (
      orgUserSendInviteReq: OrgUserSendInviteReq,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgUserSendInviteReq' is not null or undefined
      assertParamExists('orgUserServiceSendInvite', 'orgUserSendInviteReq', orgUserSendInviteReq);
      const localVarPath = `/org_user/org_users/invite`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        orgUserSendInviteReq,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 用户邀请回调
     * @summary 用户邀请回调
     * @param {string} id
     * @param {OrgUserSendInviteCallbackReq} orgUserSendInviteCallbackReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orgUserServiceSendInviteCallback: async (
      id: string,
      orgUserSendInviteCallbackReq: OrgUserSendInviteCallbackReq,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('orgUserServiceSendInviteCallback', 'id', id);
      // verify required parameter 'orgUserSendInviteCallbackReq' is not null or undefined
      assertParamExists(
        'orgUserServiceSendInviteCallback',
        'orgUserSendInviteCallbackReq',
        orgUserSendInviteCallbackReq
      );
      const localVarPath = `/org_user/org_user/{id}/invite_callback`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        orgUserSendInviteCallbackReq,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 用户修改信息
     * @summary 用户修改信息
     * @param {string} id
     * @param {OrgUserUpdateReq} orgUserUpdateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orgUserServiceUpdate: async (
      id: string,
      orgUserUpdateReq: OrgUserUpdateReq,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('orgUserServiceUpdate', 'id', id);
      // verify required parameter 'orgUserUpdateReq' is not null or undefined
      assertParamExists('orgUserServiceUpdate', 'orgUserUpdateReq', orgUserUpdateReq);
      const localVarPath = `/org_user/org_user/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        orgUserUpdateReq,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Update single org user call method
     * @summary Update single org user call method
     * @param {string} id
     * @param {OrgUserUpdateCallMethodReq} orgUserUpdateCallMethodReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orgUserServiceUpdateCallMethod: async (
      id: string,
      orgUserUpdateCallMethodReq: OrgUserUpdateCallMethodReq,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      assertParamExists('orgUserServiceUpdateCallMethod', 'id', id);
      assertParamExists(
        'orgUserServiceUpdateCallMethod',
        'orgUserUpdateCallMethodReq',
        orgUserUpdateCallMethodReq
      );
      const localVarPath = `/org_user/org_user/{id}/call-method`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        orgUserUpdateCallMethodReq,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Batch update org user call method
     * @summary Batch update org user call method
     * @param {OrgUserBatchUpdateCallMethodReq} orgUserBatchUpdateCallMethodReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orgUserServiceBatchUpdateCallMethod: async (
      orgUserBatchUpdateCallMethodReq: OrgUserBatchUpdateCallMethodReq,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      assertParamExists(
        'orgUserServiceBatchUpdateCallMethod',
        'orgUserBatchUpdateCallMethodReq',
        orgUserBatchUpdateCallMethodReq
      );
      const localVarPath = `/org_user/org_users/call-method`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        orgUserBatchUpdateCallMethodReq,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * OrgUserServiceApi - functional programming interface
 * @export
 */
export const OrgUserServiceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = OrgUserServiceApiAxiosParamCreator(configuration);
  return {
    /**
     * 用户创建
     * @summary 用户创建
     * @param {OrgUser} orgUser
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async orgUserServiceCreate(
      orgUser: OrgUser,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.orgUserServiceCreate(
        orgUser,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['OrgUserServiceApi.orgUserServiceCreate']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 用户删除
     * @summary 用户删除
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async orgUserServiceDelete(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.orgUserServiceDelete(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['OrgUserServiceApi.orgUserServiceDelete']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 用户详情
     * @summary 用户详情
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async orgUserServiceDetail(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrgUser>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.orgUserServiceDetail(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['OrgUserServiceApi.orgUserServiceDetail']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 用户列表查询
     * @summary 用户列表查询
     * @param {string} [name]
     * @param {string} [orgId]
     * @param {number} [pageSize] 当前分页大小
     * @param {number} [pageNum] 当前页数
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async orgUserServiceFind(
      name?: string,
      orgId?: string,
      pageSize?: number,
      pageNum?: number,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrgUsers>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.orgUserServiceFind(
        name,
        orgId,
        pageSize,
        pageNum,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['OrgUserServiceApi.orgUserServiceFind']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 用户邀请
     * @summary 用户邀请
     * @param {OrgUserSendInviteReq} orgUserSendInviteReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async orgUserServiceSendInvite(
      orgUserSendInviteReq: OrgUserSendInviteReq,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrgUserSendInviteRsp>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.orgUserServiceSendInvite(
        orgUserSendInviteReq,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['OrgUserServiceApi.orgUserServiceSendInvite']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 用户邀请回调
     * @summary 用户邀请回调
     * @param {string} id
     * @param {OrgUserSendInviteCallbackReq} orgUserSendInviteCallbackReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async orgUserServiceSendInviteCallback(
      id: string,
      orgUserSendInviteCallbackReq: OrgUserSendInviteCallbackReq,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrgUserSendInviteCallbackRsp>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.orgUserServiceSendInviteCallback(
        id,
        orgUserSendInviteCallbackReq,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['OrgUserServiceApi.orgUserServiceSendInviteCallback']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 用户修改信息
     * @summary 用户修改信息
     * @param {string} id
     * @param {OrgUserUpdateReq} orgUserUpdateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async orgUserServiceUpdate(
      id: string,
      orgUserUpdateReq: OrgUserUpdateReq,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.orgUserServiceUpdate(
        id,
        orgUserUpdateReq,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['OrgUserServiceApi.orgUserServiceUpdate']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Update single org user call method
     * @summary Update single org user call method
     * @param {string} id
     * @param {OrgUserUpdateCallMethodReq} orgUserUpdateCallMethodReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async orgUserServiceUpdateCallMethod(
      id: string,
      orgUserUpdateCallMethodReq: OrgUserUpdateCallMethodReq,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrgUserUpdateCallMethodRsp>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.orgUserServiceUpdateCallMethod(
        id,
        orgUserUpdateCallMethodReq,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['OrgUserServiceApi.orgUserServiceUpdateCallMethod']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Batch update org user call method
     * @summary Batch update org user call method
     * @param {OrgUserBatchUpdateCallMethodReq} orgUserBatchUpdateCallMethodReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async orgUserServiceBatchUpdateCallMethod(
      orgUserBatchUpdateCallMethodReq: OrgUserBatchUpdateCallMethodReq,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrgUserBatchUpdateCallMethodRsp>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.orgUserServiceBatchUpdateCallMethod(
        orgUserBatchUpdateCallMethodReq,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['OrgUserServiceApi.orgUserServiceBatchUpdateCallMethod']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * OrgUserServiceApi - factory interface
 * @export
 */
export const OrgUserServiceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = OrgUserServiceApiFp(configuration);
  return {
    /**
     * 用户创建
     * @summary 用户创建
     * @param {OrgUser} orgUser
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orgUserServiceCreate(orgUser: OrgUser, options?: any): AxiosPromise<void> {
      return localVarFp
        .orgUserServiceCreate(orgUser, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 用户删除
     * @summary 用户删除
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orgUserServiceDelete(id: string, options?: any): AxiosPromise<void> {
      return localVarFp.orgUserServiceDelete(id, options).then(request => request(axios, basePath));
    },
    /**
     * 用户详情
     * @summary 用户详情
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orgUserServiceDetail(id: string, options?: any): AxiosPromise<OrgUser> {
      return localVarFp.orgUserServiceDetail(id, options).then(request => request(axios, basePath));
    },
    /**
     * 用户列表查询
     * @summary 用户列表查询
     * @param {string} [name]
     * @param {string} [orgId]
     * @param {number} [pageSize] 当前分页大小
     * @param {number} [pageNum] 当前页数
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orgUserServiceFind(
      name?: string,
      orgId?: string,
      pageSize?: number,
      pageNum?: number,
      options?: any
    ): AxiosPromise<OrgUsers> {
      return localVarFp
        .orgUserServiceFind(name, orgId, pageSize, pageNum, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 用户邀请
     * @summary 用户邀请
     * @param {OrgUserSendInviteReq} orgUserSendInviteReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orgUserServiceSendInvite(
      orgUserSendInviteReq: OrgUserSendInviteReq,
      options?: any
    ): AxiosPromise<OrgUserSendInviteRsp> {
      return localVarFp
        .orgUserServiceSendInvite(orgUserSendInviteReq, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 用户邀请回调
     * @summary 用户邀请回调
     * @param {string} id
     * @param {OrgUserSendInviteCallbackReq} orgUserSendInviteCallbackReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orgUserServiceSendInviteCallback(
      id: string,
      orgUserSendInviteCallbackReq: OrgUserSendInviteCallbackReq,
      options?: any
    ): AxiosPromise<OrgUserSendInviteCallbackRsp> {
      return localVarFp
        .orgUserServiceSendInviteCallback(id, orgUserSendInviteCallbackReq, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 用户修改信息
     * @summary 用户修改信息
     * @param {string} id
     * @param {OrgUserUpdateReq} orgUserUpdateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orgUserServiceUpdate(
      id: string,
      orgUserUpdateReq: OrgUserUpdateReq,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .orgUserServiceUpdate(id, orgUserUpdateReq, options)
        .then(request => request(axios, basePath));
    },
    /**
     * Update single org user call method
     * @summary Update single org user call method
     * @param {string} id
     * @param {OrgUserUpdateCallMethodReq} orgUserUpdateCallMethodReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orgUserServiceUpdateCallMethod(
      id: string,
      orgUserUpdateCallMethodReq: OrgUserUpdateCallMethodReq,
      options?: any
    ): AxiosPromise<OrgUserUpdateCallMethodRsp> {
      return localVarFp
        .orgUserServiceUpdateCallMethod(id, orgUserUpdateCallMethodReq, options)
        .then(request => request(axios, basePath));
    },
    /**
     * Batch update org user call method
     * @summary Batch update org user call method
     * @param {OrgUserBatchUpdateCallMethodReq} orgUserBatchUpdateCallMethodReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orgUserServiceBatchUpdateCallMethod(
      orgUserBatchUpdateCallMethodReq: OrgUserBatchUpdateCallMethodReq,
      options?: any
    ): AxiosPromise<OrgUserBatchUpdateCallMethodRsp> {
      return localVarFp
        .orgUserServiceBatchUpdateCallMethod(orgUserBatchUpdateCallMethodReq, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * OrgUserServiceApi - object-oriented interface
 * @export
 * @class OrgUserServiceApi
 * @extends {BaseAPI}
 */
export class OrgUserServiceApi extends BaseAPI {
  /**
   * 用户创建
   * @summary 用户创建
   * @param {OrgUser} orgUser
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrgUserServiceApi
   */
  public orgUserServiceCreate(orgUser: OrgUser, options?: RawAxiosRequestConfig) {
    return OrgUserServiceApiFp(this.configuration)
      .orgUserServiceCreate(orgUser, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 用户删除
   * @summary 用户删除
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrgUserServiceApi
   */
  public orgUserServiceDelete(id: string, options?: RawAxiosRequestConfig) {
    return OrgUserServiceApiFp(this.configuration)
      .orgUserServiceDelete(id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 用户详情
   * @summary 用户详情
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrgUserServiceApi
   */
  public orgUserServiceDetail(id: string, options?: RawAxiosRequestConfig) {
    return OrgUserServiceApiFp(this.configuration)
      .orgUserServiceDetail(id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 用户列表查询
   * @summary 用户列表查询
   * @param {string} [name]
   * @param {string} [orgId]
   * @param {number} [pageSize] 当前分页大小
   * @param {number} [pageNum] 当前页数
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrgUserServiceApi
   */
  public orgUserServiceFind(
    name?: string,
    orgId?: string,
    pageSize?: number,
    pageNum?: number,
    options?: RawAxiosRequestConfig
  ) {
    return OrgUserServiceApiFp(this.configuration)
      .orgUserServiceFind(name, orgId, pageSize, pageNum, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 用户邀请
   * @summary 用户邀请
   * @param {OrgUserSendInviteReq} orgUserSendInviteReq
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrgUserServiceApi
   */
  public orgUserServiceSendInvite(
    orgUserSendInviteReq: OrgUserSendInviteReq,
    options?: RawAxiosRequestConfig
  ) {
    return OrgUserServiceApiFp(this.configuration)
      .orgUserServiceSendInvite(orgUserSendInviteReq, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 用户邀请回调
   * @summary 用户邀请回调
   * @param {string} id
   * @param {OrgUserSendInviteCallbackReq} orgUserSendInviteCallbackReq
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrgUserServiceApi
   */
  public orgUserServiceSendInviteCallback(
    id: string,
    orgUserSendInviteCallbackReq: OrgUserSendInviteCallbackReq,
    options?: RawAxiosRequestConfig
  ) {
    return OrgUserServiceApiFp(this.configuration)
      .orgUserServiceSendInviteCallback(id, orgUserSendInviteCallbackReq, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 用户修改信息
   * @summary 用户修改信息
   * @param {string} id
   * @param {OrgUserUpdateReq} orgUserUpdateReq
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrgUserServiceApi
   */
  public orgUserServiceUpdate(
    id: string,
    orgUserUpdateReq: OrgUserUpdateReq,
    options?: RawAxiosRequestConfig
  ) {
    return OrgUserServiceApiFp(this.configuration)
      .orgUserServiceUpdate(id, orgUserUpdateReq, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Update single org user call method
   * @summary Update single org user call method
   * @param {string} id
   * @param {OrgUserUpdateCallMethodReq} orgUserUpdateCallMethodReq
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrgUserServiceApi
   */
  public orgUserServiceUpdateCallMethod(
    id: string,
    orgUserUpdateCallMethodReq: OrgUserUpdateCallMethodReq,
    options?: RawAxiosRequestConfig
  ) {
    return OrgUserServiceApiFp(this.configuration)
      .orgUserServiceUpdateCallMethod(id, orgUserUpdateCallMethodReq, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Batch update org user call method
   * @summary Batch update org user call method
   * @param {OrgUserBatchUpdateCallMethodReq} orgUserBatchUpdateCallMethodReq
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrgUserServiceApi
   */
  public orgUserServiceBatchUpdateCallMethod(
    orgUserBatchUpdateCallMethodReq: OrgUserBatchUpdateCallMethodReq,
    options?: RawAxiosRequestConfig
  ) {
    return OrgUserServiceApiFp(this.configuration)
      .orgUserServiceBatchUpdateCallMethod(orgUserBatchUpdateCallMethodReq, options)
      .then(request => request(this.axios, this.basePath));
  }
}
